export default __webpack_public_path__ + "static/SSSpyView_screenshot-4-2352f885373552c718d54ad60be14a9f.jpg";